import { supabase } from '../supabase/supabase';

export const fetchSellerTaxInformation = async (sellerId) => {
  const { data, error } = await supabase.rpc(
    'seller_get_tax_information_with_pickup_1793086000000',
    { p_seller_id: sellerId }
  );

  if (error) throw error;

  return data;
};

export const updateSellerTaxInformation = async (sellerId, values) => {
  const pickupAddress = values.pickup_tax_address || {};
  const hasPickupAddress = [
    pickupAddress.line1,
    pickupAddress.city,
    pickupAddress.postal_code
  ].some((value) => String(value || '').trim());

  const { data, error } = await supabase.rpc(
    'seller_update_tax_information_with_pickup_1793086000000',
    {
      p_seller_id: sellerId,
      p_tax_registration_status: values.tax_registration_status,
      p_gst_hst_registration_number: values.gst_hst_registration_number,
      p_tax_business_province: values.tax_business_province,
      p_tax_acknowledgement_accepted: values.tax_acknowledgement_accepted,
      p_online_payment_requirements_complete:
        values.online_payment_requirements_complete,
      p_pickup_tax_address: hasPickupAddress
        ? { ...pickupAddress, country: 'CA' }
        : null
    }
  );

  if (error) throw error;

  return data;
};
